<dx-load-panel
  shadingColor="rgba(255,255,255,0.4)"
  [position]="{ of: '#opath-core-layout' }"
  [visible]="showLoader"
  [message]="loaderText"
  [showIndicator]="true"
  [showPane]="true"
  [shading]="true"
  [hideOnOutsideClick]="false"
>
</dx-load-panel>
<div id="opath-core-layout" class="layout-container" [style.flexDirection]="rtlEnabled ? 'row' : 'row-reverse'">
  <div class="content-container" [style.width]="hasVisibleSideControlButtons ? 'calc(100% - 40px)' : '100%'">
    <opath-core-topbar [controlButtons]="topControlButtons" [rtlEnabled]="rtlEnabled"></opath-core-topbar>
    <ng-content></ng-content>
  </div>
  <div *ngIf="hasVisibleSideControlButtons">
    <opath-core-sidebar [controlButtons]="sideControlButtons"></opath-core-sidebar>
  </div>
</div>
